export default "__VITE_ASSET__87c4419f__";